<template>
    <div>
        <el-dialog title='拆分批次' :visible.sync='Splitdiag' :close-on-click-modal='false' :close-on-press-escape='false'
                   width='600px' v-dialogDrag @close='close' append-to-body>
            <el-button type='primary' style='margin-bottom: 20px;' @click='forgroup'>分组</el-button>
            <taxtable :headData='spiltheadData' ref='spiltbox' showSelection @selectionchange='selectionchange'
                      :tableData='spilttableData'>
            </taxtable>
            <span slot='footer' class='dialog-footer'>
		   <el-button type='primary' @click='submitSplit'>保存</el-button>
		    <el-button @click='close'>取消</el-button>
		  </span>
        </el-dialog>
    </div>
</template>

<script>
import { splitFeeCollection } from '../../../../api/home';

export default {
    props: {
        Splitdiag: {
            type: Boolean,
            default: false
        },
        spilttableData: {
            type: Array,
            default: function() {
                return [];
            }
        }

    },
    data() {
        return {
            spiltheadData: [
                {
                    title: '发票号码',
                    prop: 'invoiceNumber'
                },
                {
                    title: '发票代码',
                    prop: 'invoiceCode'
                },
                {
                    title: 'po号',
                    prop: 'poNumber'
                },
                {
                    title: '分组批次号',
                    prop: 'groupNumber'
                }
            ]
        };
    },

    methods: {
        forgroup() {
            let choosearr = this.$refs.spiltbox.getSelectionval();
            if (this.emptyandnull(choosearr)) {
                this.$message.error('请选择要分组的数据');
                return false;
            }
            this.spilttableData.forEach(item => {
                choosearr.forEach(gtem => {
                    if (item.id == gtem.id) {
                        item.groupNumber++;
                    }
                });
            });
            let newarr = JSON.parse(JSON.stringify(this.spilttableData));
            this.spilttableData = newarr;
        },
        selectionchange() {

        },
        // 关闭弹框
        close() {
            this.$emit('closeSplitdiag', false);
        },
        submitSplit() {
            console.log(this.spilttableData);
            splitFeeCollection(this.spilttableData).then(res => {
                if (res.data.success) {
                    this.$message.success('拆分成功');
                    let data = {};
                    this.$emit('submitSplit', data);
                    this.close();
                } else {
                    this.$message.error('拆分失败:' + res.data.data);
                }

            });
        }

    }
};
</script>

<style scoped='scoped' lang='less'>

</style>
